<template>
  <div class="ws-state-range-input">
    <WsText001
      h6
      bold
      required
    >
      {{ $t(title) }}<span class="red">*</span>
    </WsText001>
    <div class="ws-state-range-input__container mt-8">
      <div class="range-imput__item">
        <StateInputButton
          ref="lowerData"
          :value="rangeData.lower"
          :error-messages="lowerErrorMessage"
          :custom-messages="customMessages"
          type="number"
          :placeholder="lowerDataPlaceholder"
          :rules="$_minLimitRules(lowerLimit)"
          :required="_isUpperValue"
          @input="$_onInput($event, 'lower')"
        />
        <!-- 管制界線下限不可小於合規界線 -->
      </div>
      <WsText001
        h5
        bold
        class="ml-10 mr-10"
      >
        ~
      </WsText001>
      <div class="ws-state-range-input__item">
        <StateInputButton
          ref="upperData"
          :value="rangeData.upper"
          type="number"
          :error-messages="upperErrorMessage"
          :custom-messages="customMessages"
          :rules="$_maxLimitRules(upperLimit)"
          :placeholder="upperDataPlaceholder"
          :required="_isLowerValue"
          @input="$_onInput($event, 'upper')"
        />
        <!-- 管制界線上限不可大於合規界線 -->
      </div>
    </div>
    <WsTextButton001
      v-if="popUpBtn"
      primary
      is-icon-sm
      no-padding
      leading-icon="icon-warning"
      class="mt-8"
      @click="$_popupOpen()"
    >
      {{ popUpBtn }}
    </WsTextButton001>
    <PopUp
      :pop-up-active="popupActive"
      @click="$_popupClose()"
    >
      <div class="popup-title">
        <p class="title">
          {{ $t(popupTitle) }}
        </p>
      </div>
      <div class="popup-content">
        {{ popupContent }}
      </div>
    </PopUp>
  </div>
</template>
<script>
export default {
  name: "WsStateRangeInput001",
  props: {
    lowerLimit: {
      type: Number,
      default: 0,
    },
    upperLimit: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    rangeData: {
      type: Object,
      default() {
        return {};
      },
    },
    popUpBtn: {
      type: String,
      default: "",
    },
    lowerErrorMessage: {
      type: String,
      default: "",
    },
    upperErrorMessage: {
      type: String,
      default: "",
    },
    lowerDataPlaceholder: {
      type: String,
      default: "",
    },
    upperDataPlaceholder: {
      type: String,
      default: "",
    },
    popupTitle: {
      type: String,
      default: "",
    },
    popupContent: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: true,
    },
    customMessages: {
      type: Object,
    },
  },
  data: () => ({
    popupActive: false,
  }),
  computed: {
    _isUpperValue() {
      return this.$_isValueNotNullNotEmpty(this.rangeData.upper);
    },
    _isLowerValue() {
      return this.$_isValueNotNullNotEmpty(this.rangeData.lower);
    },
  },
  methods: {
    $_popupOpen() {
      this.popupActive = true;
    },
    $_popupClose() {
      this.popupActive = false;
    },
    $_minLimitRules(min) {
      if (!this.required) {
        return '';
      } else if (min) {
        return this._isUpperValue
          ? `required|customedMinValue:${min}|max_value:${this.rangeData.upper}`
          : `customedMinValue:${min}`;
      } else {
        return this._isUpperValue
          ? `required|max_value:${this.rangeData.upper}`
          : '';
      }
    },
    $_maxLimitRules(max) {
      if (!this.required) {
        return '';
      } else if (max) {
        return this._isLowerValue
          ? `required|customedMaxValue:${max}|min_value:${this.rangeData.lower}`
          : `customedMaxValue:${max}`;
      } else {
        return this._isLowerValue
          ? `required|min_value:${this.rangeData.lower}`
          : '';
      }
    },
    $_onInput($event, key) {
      const resultRangeData = {...this.rangeData};
      resultRangeData[key] = $event;
      this.$emit('input', resultRangeData);
    },
    $_isValueNotNullNotEmpty(value){
      return value !== '' && value !== null;
    }
  },
};
</script>